module.exports = __webpack_public_path__ + "static/media/face_terminal_icon.b7609990.svg";